import { createSelector } from "@reduxjs/toolkit";

const selectPermissions = (state) => state.auth.permissions;

/**
 * Builds the sidebar menu tree from backend permissions (single source of truth).
 * Memoized so the same tree reference is returned when permissions haven't changed (fixes unnecessary rerenders).
 */
export const selectAllowedMenus = createSelector(
  [selectPermissions],
  (permissions) => {
    const list = permissions || [];
    const viewable = list
      .filter((p) => p && p.can_view)
      .map((p) => ({ ...p, sort_order: p.sort_order ?? 0 }))
      .sort((a, b) => a.sort_order - b.sort_order);

    if (viewable.length === 0) return [];

    const bySlug = {};
    viewable.forEach((p) => {
      bySlug[p.slug] = { ...p, children: [] };
    });

    const roots = [];
    viewable.forEach((p) => {
      const node = bySlug[p.slug];
      const parentSlug = p.parent_slug || null;
      if (!parentSlug || !bySlug[parentSlug]) {
        roots.push(node);
      } else {
        bySlug[parentSlug].children.push(node);
      }
    });

    roots.sort((a, b) => a.sort_order - b.sort_order);
    roots.forEach((r) => r.children.sort((a, b) => a.sort_order - b.sort_order));

    return roots;
  }
);
